<template>
    <div class="dsp-score" v-if="dsp.tests && dsp.tests.length">
        <h2 class="h3 text-bold">GreatSchools Rating</h2>

        <div class="f7"> The school rating calculation is based on four ratings: the <b class="text-bold">Student Progress Rating</b> or <b class="text-bold">Academic Progress Rating</b>, <b class="text-bold">College Readiness Rating</b>, <b class="text-bold">Equity Rating</b>, and <b class="text-bold">Test Score Rating</b> each designed to show different facets of school success. <a href="https://www.greatschools.org/gk/ratings/" rel="nofollow" class="link">Learn more about GreatSchools Ratings</a> </div>
        <div class="dsp-score-section">
            <div v-for="(item,i) in dsp.tests" :class="{'active': i===typeIndex}" :index="i">
                <button type="button" @click="updateIndex(i, 0)" :class="{'link': i!==typeIndex}">
                    <b v-if="i>0" class="f4">{{item.name}} <span v-tip :tip="tip1"> <i class="f7 text-gray icon-question-circle"></i> </span></b>
                    <b v-else class="f4">{{item.name}} <span v-tip :tip="tip"> <i class="f7 text-gray icon-question-circle"></i> </span></b>
                </button>
                <div class="dsp-score-panel"  v-if="item.score && item.score.details && item.score.details.length">
                    <ul class="tab tab-bookmark">
                        <li v-for="(grade, j) in item.score.details"><button type="button" @click="updateIndex(i, j)" :class="{'active': j === gradeIndex}" :grade="grade.grade">{{grade.grade}}</button></li>
                    </ul>
                </div>
            </div>
            <div class="dsp-socre-content" :panel="typeIndex">
                <mvtChart :data="chartData" v-if="chartData"></mvtChart>
            </div>
        </div>
    </div>
</template>
<script src="./dsp-score.js"></script>
<style lang="scss">
@use "./dsp-score.scss" as *;
</style>